import styled, { css } from 'styled-components';

import { Dialog, Text16SB } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';

interface ConfirmModalContentProps {
  $textAlign: string;
  $maxWidth?: number;
}

export const ConfirmationDialogStyled = styled(Dialog)`
  width: 460px;
`;

export const ConfirmModalContent = styled(Dialog.Content)<ConfirmModalContentProps>`
  && {
    text-align: ${({ $textAlign }) => $textAlign};

    ${(props) =>
      props.$maxWidth &&
      css`
        max-width: ${props.$maxWidth}px;
      `}
  }
`;

export const Title = styled(Text16SB)`
  color: ${Colors.DarkerText};
`;

export const ConfirmModalDescription = styled.div`
  margin-top: 8px;
  color: ${Colors.Dark};
`;
